export default __webpack_public_path__ + "static/media/blob.eeac6059.svg";